<template>
	<div
		:class="['panel', 'partners',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
		:style="block.background_image_default.src ?
			'background-image:url(' + block.background_image_default.src + ')' : ''"
	>
		<!-- Это тип 2 -->
		<div class="container">
			<div v-if="isHeaderVisible" :class="'panel_header' + (isBrand ? ' sk' : '')">
				<div class="row align-items-end">
					<div class="col-12">
						<h2>{{ block.block_title }}</h2>
					</div>
				</div>
			</div>
			<div class="partners_block type2">
				<ul class="partners_list row">
					<li
						v-for="(item, index) in block.content.partners"
						:key="index"
						class="col-12 col-md-12"
						:class="(block.content.partners.length ==3 ? 'col-lg-4' : 'col-lg-6')"
					>
						<div class="partner_about_block">
							<div v-if="item.partner_image_default" class="image">
								<b-img-lazy :src="item.partner_image_default.src" alt="" />
							</div>
							<p class="title">
								{{ item.title }}
							</p>
							<div class="description" v-html=" item.description" />
							<a
								v-if="item.button_url"
								target="_blank"
								:href="item.button_url"
								class="btn btn-secondary"
							>{{ item.button_title }}</a>
						</div>
					</li>
				</ul>
			</div>
			<!--
        <div class="panel_footer">
          <div class="row">
            <div class="col-12">
              <nuxt-link to="#" class="btn btn-primary">Подробнее о центрах</nuxt-link>
            </div>
          </div>
        </div>
        -->
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'Partners',
	mixins: [panel],
};
</script>

<style lang="scss" scoped>
  @import "~/assets/styles/components/home/panel-partners";
</style>
